import {
	MESSAGE_BON_SECOURS_ORDERS, MESSAGE_MERCY_HEALTH_ORDERS,
	MESSAGE_NO_AGENTS_AVAILABLE_BS, MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT,
	MESSAGE_NO_AGENTS_AVAILABLE_MH, MESSAGE_NO_AGENTS_AVAILABLE_ORDERS,
	MESSAGE_STANDARD_INFO, QUEUE_NAME_BON_SECOURS_ORDERS,
	QUEUE_NAME_BON_SECOURS_SERVICE, QUEUE_NAME_MERCY_HEALTH_ORDERS,
	QUEUE_NAME_MERCY_HEALTH_SERVICE
} from "./constants";

export const config = {
	isStandalone: true,
	apiKey: "50282558-e56a-443d-b409-a6b1a442acf1",
	messages: {
		//firstStartMessage: [{title: MESSAGE_STANDARD_INFO}],
		//secondStartMessage: [],
		// waitingAgentEventMessage: '',
		// cancelLiveChatMessage: {title: '', buttons: []},

	},
	enableFeedbackForAllAgents: true,
	hooks: {
		/** @Function: getFirstStartMessages
		 *  @Return: array => [{title: 'text'}, ...]
		 */
		getFirstStartMessages: (props) => {
			// return empty
		},

		/** @Function: getSecondStartMessages
		 *  @Return: array => [{title: 'text'}, ...]
		 */
		getSecondStartMessages: (props) => {
			if (config.startQueueName === QUEUE_NAME_BON_SECOURS_ORDERS) {
				return [{title: MESSAGE_BON_SECOURS_ORDERS}];
			} else if (config.startQueueName === QUEUE_NAME_MERCY_HEALTH_ORDERS) {
				return [{title: MESSAGE_MERCY_HEALTH_ORDERS}];
			}
			return [{title: MESSAGE_STANDARD_INFO}];
		},

		/** @Function: getQueueType
		 *  @Return: integer
		 */
		// getQueueType: (props) => {},

		/** @Function: getWaitingAgentEventMessage
		 *  @Return: string
		 */
		getWaitingAgentEventMessage: (props) => {
			if (config.startQueueName === QUEUE_NAME_BON_SECOURS_SERVICE) {
				return MESSAGE_NO_AGENTS_AVAILABLE_BS;
			} else if (config.startQueueName === QUEUE_NAME_MERCY_HEALTH_SERVICE) {
				return MESSAGE_NO_AGENTS_AVAILABLE_MH;
			} else if (config.startQueueName === QUEUE_NAME_BON_SECOURS_ORDERS
				|| config.startQueueName === QUEUE_NAME_MERCY_HEALTH_ORDERS
			) {
				return MESSAGE_NO_AGENTS_AVAILABLE_ORDERS;
			} else {
				return MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT;
			}
		},

		/** @Function: getMessageAgentConnected
		 *  @Return: string
		 */
		getMessageAgentConnected: () => {
			// return empty
		},

		/** @Function: getMessageAfterAgentConnected
		 *  @Return: string
		 */
		getMessageAfterAgentConnected: (agentName) => {
			return "My name is " + agentName + ", I may need to ask you a few questions " +
				"in order for me to better assist you!";
		},
	}
};